import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal, closeModal } from "../../store/slices/editModalSlice";
import {
  closeModalDelete,
  openModalDelete,
} from "../../store/slices/deleteModalExamsSlice";
import InfoModal from "../Modals/InfoModal";
import EditModalExams from "../Modals/EditModal/EditModalExams";
import DeleteModalExams from "../Modals/DeleteModal/DeleteModalExams";

const TableItemsExamsResponsive = ({ dataExams, onEditSuccess }) => {
  const dispatch = useDispatch();
  const deleteModalState = useSelector((state) => state.deleteModalExams);
  const editModalState = useSelector((state) => state.editModalExams);

  const handleCloseModal = (modalType) => {
    if (modalType === "edit") {
      dispatch(closeModal());
    } else if (modalType === "delete") {
      dispatch(closeModalDelete());
    } else if (modalType === "info") {
      dispatch(closeModalDelete());
    }
  };

  const handleOpenModal = (id) => {
    dispatch(openModal(id));
  };

  const handleEditItem = (id) => {
    dispatch(openModal(id));
  };

  const handleDeleteItem = (id) => {
    dispatch(openModalDelete(id));
  };

  function getYesNoTextFromBoolean(value) {
    return value ? "Po" : "Jo";
  }

  return (
    <>
      <div className="block sm:hidden space-y-4">
        {dataExams?.data?.map((item) => (
          <div
            key={item.id}
            className="bg-white shadow rounded-lg p-4 text-sm space-y-2"
          >
            <p>
              <strong>Emri i testit:</strong> {item.name}
            </p>
            <p>
              <strong>Kategoria:</strong> {item.categoryName}
            </p>
            <p>
              <strong>Premium:</strong>{" "}
              {getYesNoTextFromBoolean(item.isPremium)}
            </p>

            <div className="flex flex-wrap items-center gap-3 pt-2">
              <button className="text-blue-500">
                <InfoModal
                  title="Info rreth testit"
                  name="Emri i testit"
                  categoryInInfo="Kategoria e testit"
                />
              </button>
              <button
                className="text-success"
                onClick={() => handleEditItem(item.id)}
              >
                <EditModalExams
                  id={item.id}
                  title="Edito një test"
                  submitButtonText="Edito testin"
                  examsName="Emri testit"
                  examsCategoryId="Lloji i kategorisë"
                  premiumStatus="A eshte premium"
                  isOpen={editModalState[item.id] === true}
                  onSuccess={onEditSuccess}
                />
              </button>
              <button
                className="text-danger"
                onClick={() => handleDeleteItem(item.id)}
              >
                <DeleteModalExams id={item.id} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TableItemsExamsResponsive;
